/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentAnalyzeMonitorReviewsAssignedConversationIssueRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.reviews.assigned.conversation.issue',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentAnalyzeMonitorReviewsAssignedConversationIssueRoute);
